import { atom } from 'recoil';
import { CompetitionMap } from '../../types/competition';


export const competitionsState = atom<CompetitionMap>({
  key: 'competitions',
  default: {},
});
